import React, { memo, useCallback, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getFieldName } from "src/utils/helpers";
import {
  resetConsolidatedFilterData,
  setConsolidatedFilterDataField,
  setGridCurrentPageConsolidatedInvoice,
} from "src/redux/slices/invoiceSlice";
import { InputText } from "primereact/inputtext";
import FilterActionButtons from "src/components/FilterActionButtons/FilterActionButtons";
import ToggleFilter from "src/components/ToggleFilter/ToggleFilter";
import useResize from "src/hooks/useResize";
import { isSelectedFilterStatusIsCompleted } from "src/utils/common";
import { setChangeHistoricalDataSource } from "src/redux/slices/sharedSlice";
import { showHistoricalDataChangeSource } from "src/resources/enum";

const ConsolidatedInvoicesFilter = memo(() => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common", "registration", "invoice"]);

  const { isMobile } = useResize();
  const [isFilterShown, setIsFilterShown] = useState(!isMobile);

  const { paymentStatus, invoiceNumber } = useSelector(
    (state: any) => state.invoices.consolidatedFilterData
  );
  const handleFormSubmit = (e: any) => {
    e.preventDefault();
  };
  const invoiceStatusOptions = useSelector(
    (state: any) => state.lookup.consolidatedInvoiceStatusOptions
  );
  const language = useSelector((state: any) => state.lookup.language);

  const handleFilter = () => {
    goToGridFirstPage();
  };

  const goToGridFirstPage = useCallback(() => {
    dispatch(setGridCurrentPageConsolidatedInvoice(0) as any);
  }, []);

  const handleFormFieldChange = (e: any) => {
    let name, value;
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = e.name;
      value = e.value;
    }
    dispatch(setConsolidatedFilterDataField({ field: name, value }));
    if (name === "paymentStatus") {
      dispatch(setChangeHistoricalDataSource(showHistoricalDataChangeSource.ConsolidatedInvoice));
      dispatch(setConsolidatedFilterDataField({ field: "showHistoricalData", value: isSelectedFilterStatusIsCompleted(invoiceStatusOptions, value) }));
    }
  };

  const handleClearFilterForm = (): void => {
    dispatch(resetConsolidatedFilterData());
    goToGridFirstPage();
  };
  const toggleFilter = () => {
    setIsFilterShown(!isFilterShown);
  };
  return (
    <>
      <ToggleFilter onClick={toggleFilter} />
      <div className={`pt-3 pb-2 px-2 maintenance-requests-filter assigned-buildings-filter ${
          !isMobile || isFilterShown ? "d-flex" : "d-none"
        }`}>
        <p className="d-flex m-0 me-2 ms-2 mb-2 align-items-center fit-content filter-by-label">
          {t("filterBy")}
        </p>
        <form onSubmit={handleFormSubmit}>
          <div className="filter-row mb-2">
            <InputText
              type="text"
              placeholder={t("consolidatedInvoiceNumber")}
              onChange={handleFormFieldChange}
              value={invoiceNumber}
              name="invoiceNumber"
            />
            <Dropdown
              filter
              resetFilterOnHide
              emptyFilterMessage={t("noResultsFound")}
              id="paymentStatus"
              options={invoiceStatusOptions}
              placeholder={t("invoiceStatus")}
              className="status-dropdown"
              panelClassName="status-dropdown-panel"
              onChange={handleFormFieldChange}
              value={paymentStatus}
              optionValue={"id"}
              optionLabel={getFieldName(language)}
              name="paymentStatus"
            />
            <FilterActionButtons
              handleFilter={handleFilter}
              handleClear={handleClearFilterForm}
            />
          </div>
        </form>
      </div>
    </>
  );
});

export default ConsolidatedInvoicesFilter;
